import React from "react";
const WHATSAPP_IMAGE = "https://cdn.magicpatterns.com/uploads/juURZGpjvh5nZ4Kr2WFeYU/bono_3_collage_mensajes_whatsapp.webp";
export function WhatsAppPreview() {
  return <div className="overflow-hidden rounded-xl bg-cream-50 ring-1 ring-cocoa-900/10" data-id="element-77" data-mp="geo50n69boav">
      <img src={WHATSAPP_IMAGE} alt="Biblioteca de 57 mensajes para WhatsApp Business: primer contacto, presupuestos, confirmación y pagos" width={1568} height={1176} loading="lazy" className="block h-auto w-full" data-id="element-78" data-mp="gcutatgsedw0" />
    </div>;
}